import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { SmBaseService } from './sm-base.service';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';
import { Subscription } from 'rxjs';

@Injectable()
export class AppService extends SmBaseService implements OnDestroy {
    private _userData: UserDataModel;
    private _subscription: Subscription;

    constructor(
        http: HttpService,
        private _authService: AuthService) {
        super(http, 'app');

        this._subscription = this._authService.onTokenChanged.subscribe(token => {
            this._userData = null;

        });
    }

    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

    getUserData(): Promise<UserDataModel> {
        if (this._userData) {
            return Promise.resolve(this._userData);
        }

        return new Promise((resolve, reject) => {
            this._getAs<UserDataModel>('userdata')
                .subscribe(
                    x => {
                        this._userData = x || this._getDefaultUserData();
                        resolve(this._userData);
                    },
                    error => {
                        this._userData = this._getDefaultUserData();
                        resolve(this._userData);
                    });
        });
    }

    getSettings(): Observable<GeneralSettingsModel> {
        return this._getAs<GeneralSettingsModel>('settings');
    }

    private _getDefaultUserData(): UserDataModel {
        return {
            username: '',
            hasPayUEnabled: false
        };
    }
}

export interface UserDataModel {
    username: string;
    hasPayUEnabled: boolean;
}

export interface GeneralSettingsModel {
    lastActualizationText: string;
    termsAndConditionsArticleId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/app.service.ts